import { NgModule } from '@angular/core';

import { IconsContainerComponent } from './icons-container.component';
import { IconName } from './icons.type';

/**
 *  @deprecated use IconsContainerComponent
 */
@NgModule({
  imports: [IconsContainerComponent],
  exports: [IconsContainerComponent],
})
export class IconsContainerModule {}

export { IconsContainerComponent };
export { IconName } from './icons.type';

export type NestedIcon = { [key: string]: IconName } & { default: IconName };

export const keyIconMap = <T extends Record<string, IconName | NestedIcon>>(v: T): T => v;
